import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchInternetBanner: null,
  fetchInternetBannerStart: null,
  fetchInternetBannerSuccess: ['internetBannerData'],
  fetchInternetBannerFailure: null,

  fetchLatestInternet: ['pageNumber'],
  fetchLatestInternetStart: null,
  fetchLatestInternetSuccess: ['latestInternet'],
  fetchLatestInternetFailure: null
});

export { Types, Creators };
